export default ({ request }) => ({
  ecomEvgBulkOrderBackoutRequestListApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/backout/request/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderBackoutRequestApproveApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/backout/request/approve',
      method: 'POST',
      data,
    })
  },
  ecomEvgBulkOrderBackoutRequestRejectApi(data = {}) {
    return request({
      url: '/ecom/evg/bulk/order/backout/request/reject',
      method: 'POST',
      data,
    })
  },
})
